module.exports = __webpack_public_path__ + "assets/fonts/Foco-Bold-8d2341621374e52c6028e8311051bff9.otf";